export default "__VITE_ASSET__DM258Zp6__"